import type { FC } from "react";
import { Grid } from "@mui/material";
import type { MetricCardModel } from "../model";
import {
  DashboardMetricCard,
  DashboardMetricCardSkeleton,
} from "./DashboardMetricCard";
import { QueryErrorAlert } from "./QueryErrorAlert";

/** Два ряда по четыре на широком экране, по две на планшете, столбиком на телефоне. */
const CARD_SIZE = { xs: 12, sm: 6, lg: 3 } as const;
const SKELETON_KEYS = ["s1", "s2", "s3", "s4", "s5", "s6", "s7", "s8"];

interface MetricCardsProps {
  cards: MetricCardModel[] | null;
  loading: boolean;
  error: boolean;
  onRetry: () => void;
}

export const MetricCards: FC<MetricCardsProps> = ({
  cards,
  loading,
  error,
  onRetry,
}) => {
  // Ошибка важнее старых карточек: они от прошлого периода.
  if (error) return <QueryErrorAlert onRetry={onRetry} />;

  return (
    <Grid container spacing={2}>
      {cards
        ? cards.map((card) => (
            <Grid key={card.key} size={CARD_SIZE}>
              <DashboardMetricCard card={card} />
            </Grid>
          ))
        : loading &&
          SKELETON_KEYS.map((key) => (
            <Grid key={key} size={CARD_SIZE}>
              <DashboardMetricCardSkeleton />
            </Grid>
          ))}
    </Grid>
  );
};
